import { Splide } from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

export function slide() {
    window.addEventListener('DOMContentLoaded', () => {
        // スライダーを初期化する
        const splideElements = document.querySelectorAll('.splide');

        splideElements.forEach(element => {
            new Splide(element).mount();
        });

        // FVの流れるテキスト
        const slideTextMvElement = document.querySelector(".js-slide-text--mv");

        if (slideTextMvElement) {
            const slideTextMv = new Splide(slideTextMvElement, {
                type: 'loop',
                perPage: 3, // 1ページに複数スライドを表示
                perMove: 1,
                gap: '40px',
                pagination: false, // ページネーションを非表示にする
                arrows: false, // 矢印を非表示にする
                autoScroll: {
                    speed: 0.5, // スクロール速度の調整
                    pauseOnHover: false,
                    pauseOnTouch: false,
                },
            });

            slideTextMv.mount({ AutoScroll });

            // スライダーの幅を動的に設定
            const updateSplideWidth = () => {
                const slides = slideTextMvElement.querySelectorAll('.splide__slide');
                let maxWidth = 0;

                slides.forEach(slide => {
                    const slideWidth = slide.getBoundingClientRect().width;
                    if (slideWidth > maxWidth) {
                        maxWidth = slideWidth;
                    }
                });

                // スライダーの幅を設定
                slideTextMv.options = { fixedWidth: maxWidth }; 
                slideTextMv.refresh(); // スライダーの再描画
            };

            // 初期表示の更新
            updateSplideWidth();

            // ウィンドウのリサイズ時にスライダーの幅を更新
            window.addEventListener('resize', updateSplideWidth);
        }
    });
}